<div class="form-card">
  <div class="card-header">
    <div class="card-header-icon estoque-icon">
      <i class="pi pi-list"></i>
    </div>
    <span class="card-header-title">{{ 'relatorio-produtos.texts.lista_de_produtos' | translate }}</span>
  </div>
  <div class="card-content">
    <div class="form-grid">

      <!-- Categoria | Subcategoria | Marca -->
      <div class="form-field third">
        <label class="form-label">{{ 'relatorio-produtos.labels.selecionar_categoria' | translate }}</label>
        <app-select-grupo [(ngModel)]="selectedGrupo" />
      </div>

      <div class="form-field third">
        <label class="form-label">{{ 'relatorio-produtos.labels.selecionar_subcategoria' | translate }}</label>
        <app-select-subgrupo [grupoId]="selectedGrupo?.id" [(ngModel)]="selectedSubGrupo" />
      </div>

      <div class="form-field third">
        <label class="form-label">{{ 'relatorio-produtos.labels.selecionar_marca' | translate }}</label>
        <app-select-marca [(ngModel)]="selectedMarca" />
      </div>

      <!-- Fornecedor -->
      <div class="form-field full">
        <label class="form-label">{{ 'relatorio-produtos.labels.selecionar_fornecedor' | translate }}</label>
        <p-dropdown [options]="fornecedores" [(ngModel)]="selectedFornecedor" optionLabel="nome"
          [filter]="true" [filterBy]="'nome,fantasia,telefone,ci,ruc,nomeCidade,codigoPessoa'" [showClear]="true"
          [placeholder]="('relatorio-itens-vendidos.placeholders.selecionar_fornecedor' | translate)"
          (onFilter)="onFornecedorFilter($event)" [loading]="loadingFornecedores" appendTo="body" styleClass="w-full">

          <ng-template pTemplate="header">
            <div class="grid font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
              <div class="col-1">{{ 'relatorio-itens-vendidos.table_headers.codigo' | translate }}</div>
              <div class="col-3">{{ 'relatorio-itens-vendidos.table_headers.nome' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.nome_fantasia' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.telefone' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.ci' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.ruc' | translate }}</div>
            </div>
          </ng-template>

          <ng-template let-fornecedor pTemplate="item">
            <div class="grid px-2 py-1 text-sm">
              <div class="col-1">{{ fornecedor.codigoPessoa }}</div>
              <div class="col-3">{{ fornecedor.nome }}</div>
              <div class="col-2">{{ fornecedor.fantasia }}</div>
              <div class="col-2">{{ fornecedor.telefone }}</div>
              <div class="col-2">{{ fornecedor.ci }}</div>
              <div class="col-2">{{ fornecedor.ruc }}</div>
            </div>
          </ng-template>

          <ng-template pTemplate="empty">
            <div class="p-2 text-center text-500">{{ 'relatorio-itens-vendidos.spans.nenhum_fornecedor_encontrado' | translate }}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Saldo -->
      <div class="form-field third">
        <label class="form-label">{{ 'relatorio-produtos.labels.selecione_o_saldo' | translate }}</label>
        <div class="radio-group">
          <div class="radio-item">
            <p-radioButton name="saldo" [value]="'TODOS'" [(ngModel)]="params.saldo" inputId="saldoAll"></p-radioButton>
            <label for="saldoAll">Todos</label>
          </div>
          <div class="radio-item">
            <p-radioButton name="saldo" [value]="'POSITIVO'" [(ngModel)]="params.saldo" inputId="saldoPos"></p-radioButton>
            <label for="saldoPos">Positivo</label>
          </div>
          <div class="radio-item">
            <p-radioButton name="saldo" [value]="'NEGATIVO'" [(ngModel)]="params.saldo" inputId="saldoNeg"></p-radioButton>
            <label for="saldoNeg">Negativo</label>
          </div>
        </div>
      </div>

      <!-- Colunas a exibir -->
      <div class="form-field full">
        <label class="form-label">
          {{ 'relatorio-produtos.labels.colunas_a_exibir' | translate }}
        </label>
        <div class="checkbox-group">
          <div class="checkbox-item">
            <p-checkbox name="exibirCusto" [(ngModel)]="params.exibirCusto"
                        binary="true" inputId="exibirCustoFlag">
            </p-checkbox>
            <label for="exibirCustoFlag">
              {{ 'relatorio-produtos.labels.exibir_custo' | translate }}
            </label>
          </div>
          <div class="checkbox-item">
            <p-checkbox name="exibirPreco" [(ngModel)]="params.exibirPreco"
                        binary="true" inputId="exibirPrecoFlag">
            </p-checkbox>
            <label for="exibirPrecoFlag">
              {{ 'relatorio-produtos.labels.exibir_preco' | translate }}
            </label>
          </div>
          <div class="checkbox-item">
            <p-checkbox name="exibirSaldo" [(ngModel)]="params.exibirSaldo"
                        binary="true" inputId="exibirSaldoFlag">
            </p-checkbox>
            <label for="exibirSaldoFlag">
              {{ 'relatorio-produtos.labels.exibir_saldo' | translate }}
            </label>
          </div>
        </div>
      </div>

      <!-- Botão Emitir -->
      <div class="form-field full">
        <div class="actions-container">
          <button pButton type="button" [disabled]="emitindoRelatorio" class="btn-primary"
            label="{{ 'relatorio-produtos.buttons.emitir_relatorio' | translate }}" icon="pi pi-file-pdf"
            (click)="emitirRelatorio()">
          </button>
          <app-loading-dialog [visible]="emitindoRelatorio"
            title="{{ 'relatorios.texts.gerando_relatorio' | translate }}" />
        </div>
      </div>

    </div>
  </div>
</div>

<p-toast></p-toast>
